export default __webpack_public_path__ + "media/images/icons_fc/phone-blue-f8c5b363e7798e8239df3bbf42242e37.png";